import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Modal as AntModal, Input, message } from "antd";
import api from "../../../../api/api";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-footer {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: center;

    .ant-btn {
      height: 48px;
      flex: 0.5;
      margin-inline-start: 0 !important;
    }
  }
`;

const Text = styled.div`
  padding: 6px;
`;
const LightText = styled.div`
  font-size: 15px;
  font-weight: 400;
  padding: 6px 0;
  color: #686868;
  white-space: pre-wrap;
  text-align: center;
`;
const _name = "[name]";

const PreviewLinkModal = ({
  open,
  handleClose,
  successCallback,
  expired,
  newLink,
  domain,
}) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");

  const {t} = useTranslation();

 
  const onOk = () => {
    if (!loading) {
      if (!name) {
        return;
      }
      setLoading(true);
      api
        .createTemplatePreviewLink({ name: domain ? "preview" : name })
        .then(({ data }) => {
          setLoading(false);
          message.success(t('preview_link_success'));
          handleClose();
          successCallback(data);
        })
        .catch((error) => {
          setLoading(false);
          message.error(error);
        });
    }
  };

  const onCancel = () => {
    !loading && handleClose();
  };

  useEffect(() => {
    setName(domain || "");
  }, [expired]);

  return (
    <Modal
      centered
      open={open}
      width={450}
      title={t('preview_link')}
      okText={t('submit')}
      onCancel={onCancel}
      onOk={onOk}
      confirmLoading={loading}
    >
      <LightText>
        {newLink
          ? t('short_name_template')
          : t('preview_link_exp')}
      </LightText>
      <Input
        value={name}
        placeholder={t('enter_name')}
        onChange={(e) => setName(e.target.value.trim().toLowerCase())}
        maxLength={50}
        showCount
        disabled={expired}
      />
      {newLink && <Text>{`https://${name || _name}.onesitecart.com`}</Text>}
    </Modal>
  );
};

export default PreviewLinkModal;
